module.exports = __webpack_public_path__ + "img/rules_11.6966d27a.png";